module.exports = __webpack_public_path__ + "static/media/logo-footer.f1dfc984.svg";